export default function* counter(iterator)
{
	let previous = 0;
	iterator = iterator || {};
	const min = iterator[Math.min.apply(0,Object.keys(iterator))];
	let sequence = 0;

	yield {sequence, increment: 0, sum: 0};

	while(1)
	{
		sequence++;
		const max = iterator[Math.max.apply(0,Object.keys(iterator).filter(v=>v<=previous))];
		const increment = (max || min || 1);
		yield {sequence, increment, sum: previous = previous + increment};
	}
}